import { render, staticRenderFns } from "./IndexGoodlist.vue?vue&type=template&id=3507c710&scoped=true&"
import script from "./IndexGoodlist.vue?vue&type=script&lang=js&"
export * from "./IndexGoodlist.vue?vue&type=script&lang=js&"
import style0 from "./IndexGoodlist.vue?vue&type=style&index=0&id=3507c710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507c710",
  null
  
)

export default component.exports